import { render, staticRenderFns } from "./MultiRoomList.vue?vue&type=template&id=1ffd9f53&scoped=true"
import script from "./MultiRoomList.vue?vue&type=script&lang=js"
export * from "./MultiRoomList.vue?vue&type=script&lang=js"
import style0 from "./MultiRoomList.vue?vue&type=style&index=0&id=1ffd9f53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd9f53",
  null
  
)

export default component.exports